<!--
  //app/components/base/BaseModal.vue
  -->

<script setup lang="ts">
import { useSlots } from "vue";
import AlertIcon from "~/components/Shared/icons/AlertIcon.vue";

type Props = {
  modalId: string;
  message?: string;
  showCloseButton?: boolean;
  isAlert?: boolean;
  isPreview?: boolean;
  isNewsletter?: boolean;
};

const slots = useSlots();
const props = defineProps<Props>();
const model = defineModel<boolean>({ required: true });
</script>

<template>
  <div
    :id="modalId"
    role="dialog"
    aria-modal="true"
    :aria-labelledby="`${modalId}-title`"
    class="fixed inset-0 z-[1999] flex items-center justify-center bg-black bg-opacity-50"
    v-if="model"
    @click="model = false"
    @keydown.esc="model = false"
    tabindex="-1"
  >
    <div
      class="relative shadow-lg rounded-lg w-auto max-w-min translate-y-14 md:translate-y-0"
      :class="[
        isPreview ? 'bg-black' : 'bg-gray-900 ',
        isNewsletter ? 'min-w-[90vw] sm:min-w-[400px] overflow-hidden' : 'min-w-80',
      ]"
      @click.stop
    >
      <div
        v-if="isAlert"
        class="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-12 h-12 rounded-full bg-red-600 text-white text-xl font-bold"
      >
        <AlertIcon />
      </div>
      <div :class="['flex items-center justify-between', { 'px-2': !isNewsletter }]">
        <div :id="`${modalId}-title`" class="flex-grow">
          <slot name="header"></slot>
        </div>
        <div v-if="showCloseButton" class="absolute top-3 ltr:right-3 rtl:left-3">
          <button
            type="button"
            class="text-white bg-gray-700 hover:bg-primary hover:text-black rounded-lg text-sm w-7 h-7 ms-auto inline-flex justify-center items-center"
            :data-modal-hide="modalId"
            @click="model = false"
          >
            <svg
              class="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>
      </div>

      <div :class="['p-4 mt-6', { 'text-center': isAlert }]">
        <slot name="body"> {{ message }} </slot>
      </div>

      <template v-if="!!slots.footer">
        <div class="p-4">
          <slot name="footer"></slot>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped></style>
